import React from 'react';
import { FiChevronDown } from 'react-icons/fi';

export function SectionHeader({ icon: Icon, title, description, children }) {
    return (
        <div className="flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 px-5 py-4">
            <div className="flex items-start gap-3">
                <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
                    <Icon className="h-4 w-4" />
                </div>

                <div>
                    <h2 className="text-sm font-bold text-slate-900">
                        {title}
                    </h2>

                    {description && (
                        <p className="mt-0.5 text-xs text-slate-500">
                            {description}
                        </p>
                    )}
                </div>
            </div>

            {children}
        </div>
    );
}

export function FieldLabel({ children, required = false }) {
    return (
        <label className="mb-1.5 block text-xs font-medium text-slate-600">
            {children}

            {required && (
                <span className="ml-1 text-red-500">*</span>
            )}
        </label>
    );
}

export function TextInput({
    value,
    onChange,
    placeholder = "",
    type = "text",
    className = "",
    ...props
}) {
    return (
        <input
            {...props}
            type={type}
            value={value ?? ""}
            onChange={onChange}
            placeholder={placeholder}
            className={`h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 ${className}`}
        />
    );
}

export function SelectInput({ value, onChange, children }) {
    return (
        <div className="relative">
            <select
                value={value ?? ""}
                onChange={onChange}
                className="h-10 w-full appearance-none rounded-lg border border-slate-200 bg-white px-3 pr-9 text-sm text-slate-800 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
            >
                {children}
            </select>

            <FiChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        </div>
    );
}

